// (c) chaehongee. Confidential and proprietary.
import type { ReactElement } from 'react'
import { X } from 'lucide-react'
import { useAppSelector, useAppDispatch } from '../../../store/hooks/hooks'
import { toggleNode } from '../../../store/slices/selectionSlice'
import styles from '../Backstage.module.css'
import { selectActiveSession, selectActiveSessionId } from '../../../store/selectors/sessionSelectors'
import { selectActiveSelectedNodeIds } from '../../../store/selectors/selectionSelectors'

export function SelectedImagePreviews(): ReactElement | null {
    const dispatch = useAppDispatch()
    const activeSessionId = useAppSelector(selectActiveSessionId)
    const session = useAppSelector(selectActiveSession)
    const selectedNodeIds = useAppSelector(selectActiveSelectedNodeIds)
    const nodes = session?.nodes || []

    const selectedNodes = selectedNodeIds
        .map((id) => nodes.find((n) => n.id === id))
        .filter((n): n is NonNullable<typeof n> => n !== undefined)

    if (selectedNodes.length === 0) {
        return null
    }

    return (
        <div className={styles.selectedPreviews}>
            {selectedNodes.map((node) => {
                const isVideo = node.type === 'video'
                return (
                    <div key={node.id} className={styles.previewItem}>
                        {isVideo ? (
                            <video
                                src={node.image_path}
                                className={styles.previewImage}
                                muted
                                playsInline
                                preload="metadata"
                            />
                        ) : (
                            <img
                                src={node.image_path}
                                alt="Selected"
                                className={styles.previewImage}
                            />
                        )}
                        <button
                            className={styles.previewRemove}
                            onClick={() => {
                                if (!activeSessionId) return
                                dispatch(
                                    toggleNode({ sessionId: activeSessionId, nodeId: node.id })
                                )
                            }}
                            aria-label="Remove selection"
                            type="button"
                        >
                            <X className={styles.previewRemoveIcon} />
                        </button>
                    </div>
                )
            })}
        </div>
    )
}

export default SelectedImagePreviews



